import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { RoleFormModal } from '../components/RoleFormModal/RoleFormModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win, and the
 * `admins.` prefix makes a collision impossible to reach by accident.
 */
export const ADMINS_MODALS = {
  ROLE_FORM: 'admins.role-form',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * The indirection is the whole point (W2): a surface opens a dialog by
 * dispatching a **string**, so one module can open another's dialog without
 * importing it, and `shared/` never reaches into `modules/` — only the bridge
 * knows what the string means.
 *
 * Every payload is IDs, never callbacks: `ModalData` is serializable-only, and
 * each modal loads what it needs from its own query. That is also what keeps an
 * open edit dialog correct while the list refetches underneath it.
 *
 * The three lifecycle dialogs are the kit's since P27c1 (`ACCOUNT_MODALS`):
 * the members page opens the same ones.
 */
export const adminsModals: readonly ModalRegistration[] = [
  { modalTypes: [ADMINS_MODALS.ROLE_FORM], component: RoleFormModal },
];
